import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  calculateTotalPages,
} from "../../../../assets/js/script";
import TableHeader from "../../../Common/TableComponent/TableHeader";
import EntriesDropdown from "../../../Common/TableComponent/EntriesDropdown";
import TablesRow from "../../../Common/TableComponent/TablesRow";
import { Pagination } from "../../../Common/TableComponent/Pagination";
import {
  getUsers,
  deleteUser,
  createPassword,
  blockUnblockUser,
} from "../../../../services/newUserService";
import { Loading } from "../../../Common/OtherElements/Loading";
import ResetPasswordModal from "./ModalComponents/ResetPasswordModal";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import allImages from "../../../../assets/images-import";
import { resolveFileUrl } from "../../../../utils/fileUrlHelper";
import { isValidProfileImageSrc } from "../../../../utils/profileImageHelper";
import { confirmDelete } from "../../../Common/OtherElements/confirmDeleteClone";
import { TableDataStatusError } from "../../../Common/OtherElements/TableDataStatusError";
import { handleErrors } from "../../../../utils/errorHandler";
import { usePageLevelAccess } from "../../../../hooks/usePageLevelAccess";

const BLOCKED_STATUS = 5;
const ACTIVE_STATUS = 2;

export const ManageUser = () => {
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [manageUsers, setManageUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  // const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUser, setSelectedUser] = useState({
    id: null,
    userName: "",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pageAccessDetails, setPageAccessDetails] = useState([]);
  const PageLevelAccessurl = "user";
  const navigate = useNavigate();
  const { pageAccessData } = usePageLevelAccess(PageLevelAccessurl);

  useEffect(() => {
    if (pageAccessData) {
      if (!pageAccessData.viewAccess) {
        navigate("/404-error-page");
      } else {
        setPageAccessDetails(pageAccessData);
      }
    } else {
      console.log("No page access details found");
    }
  }, [pageAccessData, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getUsers({
          pageSize: entriesPerPage,
          pageNo: currentPage,
          sParam: searchQuery,
          fromDate: "",
          toDate: "",
        });
        const users = response.data.result || [];
        setManageUsers(users);
        setTotalCount(users[0]?.totalCount || users.length);
      } catch (error) {
        handleErrors(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [entriesPerPage, currentPage, searchQuery]);

  const totalPages = calculateTotalPages(totalCount, entriesPerPage);

  const handleEntriesChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  const handleDelete = async (userId) => {
    const confirmed = await confirmDelete("user");
    if (confirmed) {
      try {
        await deleteUser(userId);
        setManageUsers((prev) => prev.filter((item) => item.id !== userId));
        Swal.fire("Deleted!", "User deleted successfully!", "success");
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  const handleBlockToggle = async (user) => {
    const isBlocked = Number(user.status) === BLOCKED_STATUS;
    const nextStatus = isBlocked ? "Unblock" : "Blocked";

    try {
      const response = await blockUnblockUser(user.id, nextStatus);
      if (response?.isSuccess === false) {
        toast.error(response?.message || "Unable to update user status.");
        return;
      }

      setManageUsers((prev) =>
        prev.map((item) =>
          item.id === user.id
            ? { ...item, status: isBlocked ? ACTIVE_STATUS : BLOCKED_STATUS }
            : item
        )
      );
      toast.success(response?.message || `User ${nextStatus} successfully`);
    } catch (error) {
      handleErrors(error);
    }
  };

  const handleResetPassword = async ({ id, newPassword }) => {
    try {
      const response = await createPassword({ id, newPassword });

      if (response?.isSuccess !== true) {
        toast.error(response?.message || "Password reset failed.");
        return false;
      }

      toast.success(
        `${response?.message || "Password changed successfully"}. Log in with User Name "${selectedUser.userName}".`
      );
      setShowModal(false);
      return true;
    } catch (error) {
      handleErrors(error);
      return false;
    }
  };
  return (
    <>
      <ToastContainer />
      {pageAccessDetails.viewAccess ? (
        <div className="row">
          <div className="col-xxl-12">
            <div className="card mt-xxl-n5">
              <div className="card-header">
                <h5 className="mb-sm-2 mt-sm-2">Manage Users</h5>
              </div>
              <div className="card-body manage-amenity-master-card-body">
                <div className="pagination-details-responsive justify-content-between mb-3">
                  <EntriesDropdown
                    entriesPerPage={entriesPerPage}
                    onEntriesChange={handleEntriesChange}
                    options={[10, 25, 50, 100]}
                  />
                  <div>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control mb-2"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
                {loading ? (
                  <Loading />
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle table-bordered">
                      <TableHeader
                        columns={[
                          "#",
                          "Profile Image",
                          "Name",
                          "Email Address",
                          "Phone Number",
                          "Added On",
                          "Reset Password",
                          "Block",
                          "Action",
                        ]}
                      />
                      <tbody className="manage-property-owner-table-values">
                        {manageUsers.length === 0 ? (
                          <TableDataStatusError colspan="9" />
                        ) : (
                          manageUsers.map((item, index) => (
                            <TablesRow
                              key={item.id}
                              rowData={{
                                userId:
                                  (currentPage - 1) * entriesPerPage +
                                  index +
                                  1,
                                profileImage: (
                                  <img
                                    src={
                                      isValidProfileImageSrc(item.profileImage)
                                        ? resolveFileUrl(item.profileImage)
                                        : allImages.defaultprofile
                                    }
                                    alt="Profile"
                                    className="profile-img"
                                  />
                                ),
                                userName: item.userName,
                                emailId: item.emailId,
                                contactNo: item.contactNo,
                                addedOn: new Date(
                                  item.registeredOn
                                ).toLocaleDateString(),
                                resetpassword: pageAccessDetails.editAccess ? (
                                  <span
                                    className="badge text-bg-warning"
                                    style={{ fontSize: "11px", cursor: "pointer" }}
                                    onClick={() => {
                                      setSelectedUser({
                                        id: item.id,
                                        userName: item.userName,
                                      });
                                      setShowModal(true);
                                    }}
                                  >
                                    Reset Password
                                  </span>
                                ) : (
                                  <span style={{ color: "#dc3545" }}>
                                    Forbidden
                                  </span>
                                ),
                                userStatus: (
                                  <div className="form-check form-switch form-switch-custom form-switch-primary mb-0">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={Number(item.status) !== BLOCKED_STATUS}
                                      disabled={!pageAccessDetails.editAccess}
                                      aria-label={
                                        Number(item.status) === BLOCKED_STATUS
                                          ? "Unblock user"
                                          : "Block user"
                                      }
                                      onChange={() => handleBlockToggle(item)}
                                    />
                                  </div>
                                ),
                              }}
                              columns={[
                                "userId",
                                "profileImage",
                                "userName",
                                "emailId",
                                "contactNo",
                                "addedOn",
                                "resetpassword",
                                "userStatus",
                              ]}
                              hideIcons={false}
                              onEdit={() => navigate(`update/${item.id}`)}
                              onDelete={() => handleDelete(item.id)}
                              pageLevelAccessData={pageAccessDetails}
                            />
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalEntries={totalCount}
                  entriesPerPage={entriesPerPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <ResetPasswordModal
        show={showModal}
        onHide={() => setShowModal(false)}
        userId={selectedUser.id}
        userName={selectedUser.userName}
        onReset={handleResetPassword}
      />
    </>
  );
};
